var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mb35 p20 brdr-1 brdr-cl-primary bg-cl-white",
      staticStyle: { "border-radius": "30px" }
    },
    [
      _c("div", { staticClass: "row mb15" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
          _c("h3", { staticClass: "m0 mb5" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("My complaints")) + "\n      ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c(
              "div",
              { staticStyle: { "text-align": "right" } },
              [
                _c(
                  "button-full",
                  {
                    attrs: { categoryProps: _vm.categoryProps },
                    nativeOn: {
                      click: function($event) {
                        return _vm.createComplaint($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("Create complaint")) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("create-complaint"),
            _vm._v(" "),
            _c("complaint-created")
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isComplaintsListEmpty,
                expression: "!isComplaintsListEmpty"
              }
            ],
            staticClass: "col-xs-12"
          },
          [
            _c("table", { staticClass: "brdr-1 brdr-cl-bg-secondary" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "p20 sans-serif lh20 hide-on-xs" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("RMA number")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "p20 sans-serif lh20 hide-on-xs" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("RMA type")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "p20 sans-serif lh20 hide-on-xs" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("Status")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "p20 sans-serif lh20 hide-on-xs" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("Create date")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "p20 sans-serif lh20" }, [
                    _vm._v("\n               \n            ")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.complaints, function(complaint) {
                  return _c(
                    "tr",
                    {
                      key: complaint.id,
                      staticClass: "brdr-top-1 brdr-cl-bg-secondary"
                    },
                    [
                      _c("td", { staticClass: "fs-medium lh25 hide-on-xs" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              complaint.rma_number
                                ? complaint.rma_number
                                : complaint.id
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "fs-medium lh25 hide-on-xs" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.getRMAType(complaint.rma_type)) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "fs-medium lh25 hide-on-xs" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(complaint.main_status) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "fs-medium lh25 hide-on-xs" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("date")(
                                complaint.created,
                                "DD/MM/YYYY HH:mm",
                                _vm.storeView
                              )
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "fs-medium lh25" }, [
                        _c("span", { staticClass: "relative dropdown" }, [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons cl-secondary pointer"
                            },
                            [_vm._v("more_horiz")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown-content bg-cl-primary align-left sans-serif lh20 weight-400 fs-medium-small py5"
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "no-underline block py10 px15",
                                  attrs: {
                                    to: _vm.localizedRoute(
                                      "/my-account/complaints/" + complaint.id
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("View complaint details")) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isComplaintsListEmpty,
                expression: "isComplaintsListEmpty"
              }
            ],
            staticClass: "col-xs-12 h4"
          },
          [_c("p", [_vm._v(_vm._s(_vm.$t("No complaints yet")))])]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }